import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ExtensionActivator from './view';

const ExtensionModule = ({ match }) => {
  return (
    <Switch>
      <Route exact path={match.url} component={ExtensionActivator} />
    </Switch>
  );
};

export default ExtensionModule;
